import { post } from "../helpers/apiHelper";

const RESOLVE_ENDPOINT = process.env.REACT_APP_BASE_PATH_RESOLVE;

export async function relayCreateTicket(accountId, id, data) {
  return post(`${RESOLVE_ENDPOINT}/relay/${accountId}/eform/${id}`, data);
}
